import { urlParams } from '@lhb/func';

let currentLoginCallback = '';

const LOGIN_CALLBACK_PATHS = [
  '/abside',
  '/sitemap/alltaskdetail',
  '/login/locxxredirect',
];

function sanitizeLoginCallback(callback: string) {
  const url = new URL(callback, 'http://localhost');
  if (url.hash || Array.from(url.searchParams.values()).some((value) => /token/i.test(value))) {
    return '';
  }

  const sensitiveKeys = Array.from(url.searchParams.keys()).filter((key) => /token/i.test(key));
  if (!sensitiveKeys.length) {
    return callback;
  }

  sensitiveKeys.forEach((key) => url.searchParams.delete(key));
  return `${url.pathname}${url.search}${url.hash}`;
}

/** 仅允许回跳到业务白名单内的当前站点绝对路径，避免外部重定向。 */
export function isValidLoginCallback(callback?: string): callback is string {
  if (!callback || !callback.startsWith('/') || callback.startsWith('//')) {
    return false;
  }

  try {
    const url = new URL(callback, 'http://localhost');
    return url.origin === 'http://localhost' &&
      LOGIN_CALLBACK_PATHS.includes(url.pathname) &&
      !!sanitizeLoginCallback(callback);
  } catch (error) {
    console.log(error);
    return false;
  }
}

/** 配置路径与当前路由一致时，使用包含完整查询参数的当前地址。 */
export function resolveLoginCallback(callback?: string, currentFullPath = '') {
  if (!isValidLoginCallback(callback)) {
    return '';
  }

  const safeCallback = sanitizeLoginCallback(callback);
  if (!isValidLoginCallback(currentFullPath)) {
    return safeCallback;
  }

  const callbackPathname = new URL(callback, 'http://localhost').pathname;
  const currentPathname = new URL(currentFullPath, 'http://localhost').pathname;
  return callbackPathname === currentPathname ? sanitizeLoginCallback(currentFullPath) : safeCallback;
}

/** 更新当前路由对应的登录回跳地址。 */
export function setLoginCallback(callback?: string) {
  currentLoginCallback = isValidLoginCallback(callback) ? sanitizeLoginCallback(callback) : '';
}

/** 获取当前路由对应的登录回跳地址。 */
export function getLoginCallback() {
  return currentLoginCallback;
}

/** 生成登录页地址；没有回跳地址时保持原路径。 */
export function buildLoginPath(callback = currentLoginCallback) {
  return isValidLoginCallback(callback)
    ? `/login?logincallback=${encodeURIComponent(sanitizeLoginCallback(callback))}`
    : '/login';
}

/** 从登录页或切换租户页的查询字符串中读取回跳地址。 */
export function getLoginCallbackFromSearch(search = '') {
  const rawCallback = urlParams(`http://localhost${search}`).logincallback;
  if (!rawCallback) {
    return '';
  }

  let callback = rawCallback;
  try {
    callback = decodeURIComponent(rawCallback);
  } catch (error) {
    console.log(error);
  }
  return isValidLoginCallback(callback) ? sanitizeLoginCallback(callback) : '';
}

/** 生成切租户页地址；账号与验证码登录共用同一安全回调规则。 */
export function buildChangeCompanyPath(search = '') {
  const callback = getLoginCallbackFromSearch(search);
  if (callback && new URL(callback, 'http://localhost').pathname === '/login/locxxredirect') {
    const callbackUrl = new URL(callback, 'http://localhost');
    callbackUrl.searchParams.set('forceTenantSwitch', '1');
    return `${callbackUrl.pathname}${callbackUrl.search}`;
  }
  return callback
    ? `/login/change-company?logincallback=${encodeURIComponent(callback)}`
    : '/login/change-company';
}
